export const site = Object.freeze({
  name: 'Cortis',
  origin: 'https://cortisai.com',
  app: 'https://app.cortisai.com',
  whitepaper: '/whitepaper',
  markdown: '/cortis-whitepaper.md',
  pdf: '/cortis-whitepaper.pdf',
  pdfFilename: 'Cortis_White_Paper_v1.0.pdf',
  tokenomics: null,
  socials: [
    { label: 'X · @cortis_ai', url: 'https://x.com/cortis_ai' },
    { label: 'IQ.wiki', url: 'https://iq.wiki/wiki/cortis-ai', icon: '/iq-brain.png' },
  ],
  slogan: 'Expert intelligence, one vertical at a time.',
  title: 'Cortis — Your Personal AI Operator',
  description: 'Your AI operator. One agent, trained on you, that no one else can have.',
});

export const navigation = [
  { label: 'Operator', id: 'operator' },
  { label: 'Specialists', id: 'specialists' },
  { label: 'Verification', id: 'verification' },
  { label: 'How it works', id: 'how-it-works' },
];

export const copy = {
  heroSubhead: 'One personal operator with a small, fixed roster of specialists. Trained on your private context to research, analyze, and carry out your work.',
  supporting: 'Private context. Persistent memory. Work you can trace.',
  capabilities: [
    { title: 'Research', description: 'Investigate a question and turn sources into a clear brief.', icon: 'research' },
    { title: 'Analysis', description: 'Examine information, test assumptions, and explain the tradeoffs.', icon: 'analysis' },
    { title: 'Operations', description: 'Turn recurring work into organized, actionable processes.', icon: 'operations' },
    { title: 'Growth', description: 'Develop positioning, campaign plans, and useful experiments.', icon: 'growth' },
    { title: 'Drafting / Execution', description: 'Create deliverables and carry out authorized work.', icon: 'drafting' },
  ],
  steps: [
    ['Describe your work', 'Sign in and explain what you need help with.'],
    ['Meet your operator', 'Receive a small roster of specialists built around your context.'],
    ['Put it to work', 'Work directly with your specialists. The output is yours, with an attestable record behind completed actions.'],
  ],
  attestation: 'Attestation proves the existence and binding of a record, and its time-ordering. It does not prove that the work is correct or high quality.',
  faq: [
    ['What is a personal AI operator?', 'One owner-specific operator with a small, fixed roster of specialists that work with private context and persistent memory.'],
    ['How is it different from a chatbot?', 'Cortis is organized around ongoing, specialized work for one owner, with persistent context and records of completed actions.'],
    ['What does a soulbound agent mean?', 'An agent is bound to one owner. It cannot be transferred, sold, or forked for another owner.'],
    ['Do I need crypto to use Cortis?', 'No. Sign in and begin without funding a wallet, choosing a chain, or managing gas.'],
    ['What does on-chain attestation prove?', 'It supports verification of a record’s existence, agent binding, and time-ordering. It does not prove correctness or quality.'],
    ['Is my private data shared or used to train shared models?', 'No. Private data and memory are owner-scoped and are never pooled to train shared models.'],
    ['Is $COR required?', 'No. The base product works without it. $COR is an additive utility layer and does not expand roster size.'],
  ],
  legal: '$COR is a utility token, not an investment. Nothing on this site constitutes an offer or solicitation, or financial, legal, or tax advice.',
};